// Project hooks
import { useAppSelector } from "../../services/StoreHelper";

// Styles
import header_styles from "./header_styles";

function Header() {
  const { app_dimensions, club } = useAppSelector((state) => state.app);

  // 🔹 simple toggle (same as other files)
  const { usesSpanish } = club;

  return (
    <div style={header_styles.container}>
      {app_dimensions.mobile && (
        <h5 style={header_styles.header_title}>
          {usesSpanish ? "Membresías" : "Memberships"}
        </h5>
      )}
    </div>
  );
}

export default Header;